module.exports = __webpack_public_path__ + "static/media/errorTips.fbefa487.svg";